<template>
  <div class="product-families-index-view">
    <data-grid :columns="gridColumns" :is-loading="isLoading" :page-info="productFamilies.pagination"
      :rows="productFamilies.entries" :sort-info="productFamilies.sort" :sortable="['name', 'familyNumber']"
      @sort="sortBy" class="uk-margin-medium" v-if="gridLoaded">

      <template scope="props" slot="row">
        <td>
          <router-link :to="{
            name: 'edit-product-family-revision',
            params: { id: props.row.activeRevision.id }
          }">
            {{ props.row.name }}
          </router-link>

        </td>
        <td>
          <article-number :value="props.row.familyNumber" v-if="props.row.familyNumber" />
          <text-placeholder v-else />
        </td>

        <td class="right">
          <router-link class="uk-button" tag="button" :to="{ name: 'product-family', params: { id: props.row.id } }"> product-familiy
          </router-link>
        </td>
      </template>

    </data-grid>
  </div>
</template>
  
<script>
import ArticleNumber from '@/components/ArticleNumber';
import TextPlaceholder from '@/components/TextPlaceholder';
import IndexView from '@/mixins/IndexView';
import productFamiliesActiveRevisionsQuery
  from '@/api/queries/product-families-active-revisions.graphql';

export default {
  name: 'product-families-active-revisions-view',
  mixins: [
    IndexView('productFamilies', {
      gridFields: ['name', 'family_number'],
      listQuery: productFamiliesActiveRevisionsQuery,
      nameField: 'name',
      defaultFilter() {
        const filter = {
          activeRevisions: true,
        };
        return filter;
      },
    }),
  ],
  data() {
    return {
      productFamilies: {},
    };
  },
  watch: {
    productFamilies: {
      handler(newValue) {
        this.$emit('update-active-revisions', 'product_families',
          newValue.pagination.totalCount);
      },
    },
    immediate: true,
  },
  components: {
    ArticleNumber,
    TextPlaceholder,
  },
};
</script>

<style lang="scss">
  .right {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// ProductFamiliesActiveRevisionsIndexView.vue?45cc3774